<template lang="pug">
  section
    table.table.is-bordered(v-if="manipulated_order != null")
      thead
        tr
          th.has-text-centered 配本管理ID
          th.has-text-centered レコード数
          th.has-text-centered 受注冊数
          th 出荷属性
      tbody
        tr
          td.has-text-centered
            .tag.is-rounded.is-info.is-large.has-text-weight-bold
              | {{ manipulated_order_sid }}
          td.has-text-centered.has-text-weight-bold.is-size-4
            | {{ manipulated_order.manipulated_order_items_size }}
          td.has-text-centered.has-text-weight-bold.is-size-4
            | {{ manipulated_order.total_order_number }}
          td(v-if="isEditable")
            deliver-type-id-input(
              :input_name="'deliver_type_id'"
              v-model="manipulated_order.deliver_type_id"
              :custom_errors="[]"
              :deliver_types="deliver_types"
              :disabled="isShinkan()")
          td(v-else class="has-text-centered has-text-weight-bold is-size-4")
            | {{ deliverTypeName(manipulated_order.deliver_type_id) }}
    .columns(v-if="isEditable")
      .column
        button(@click="submit" class="button is-primary")
          span.icon.icon-left
            i.fas.fa-sync-alt.fa-sm.fa-fw
          | {{ button_label }}
    .scroll-table
      b-table(:data="manipulated_order_items" :loading="loading" paginated per-page="100")
        template(slot-scope="props")
          b-table-column(field="id" label="Index" width="50")
            b-field {{ props.row.id }}
          b-table-column(field="accepting_order_sid" label="受注ID" width="150")
            b-field {{ props.row.accepting_order_sid }}
          b-table-column(field="book_name" label="書籍名:ISBN" width="400")
            b-field {{ bookName(props.row.isbn, props.row.book.name) }}

          b-table-column(field="shop_code" label="共有書店コード" width="120")
            b-field {{ props.row.shop_code }}
          b-table-column(field="ranking" label="ランキング" width="120")
            b-field {{ props.row.ranking }}
          b-table-column(field="book_shop_name" label="書店名" width="200")
            b-field {{ props.row.book_shop_name }}
          b-table-column(field="agency_code" label="帳合" width="120")
            b-field {{ agencyName(props.row.agency_code) }}

          b-table-column(field="order_route_id" label="受注経路" width="80")
            b-field {{ orderRouteName(props.row.order_route_id) }}

          b-table-column(field="sales_person_id" label="営業担当" width="80")
            b-field {{ salesPersonName(props.row.sales_person_id) }}
          b-table-column(field="kyakutyu_memo" label="客注メモ" width="200")
            b-field {{ props.row.kyakutyu_memo }}

          b-table-column(field="bibo" label="備忘" width="200")
            b-field {{ props.row.bibo }}
          b-table-column(field="accepting_date" label="受注日" width="120")
            b-field {{ props.row.accepting_date  | moment("YYYY/MM/DD") }}
          b-table-column(field="accepting_order_number" label="発注数" width="80")
            b-field {{ props.row.accepting_order_number }}
          template(v-if="isEditable")
            b-table-column(field="order_number" label="配本数" width="80")
              ValidationProvider(
                :rules="isDestroy(props.row) == false ? `required|min_value:1|max_value:${props.row.limit_order_number}` : ''"
                v-slot="{ errors }"
                name="配本数"
              )
                b-field(:type="{'is-danger': errors.length > 0 }"
                      :message="errors[0]")
                  b-input(
                    :data-vv-name="'order_number' + props.row.i"
                    data-vv-as="order_number"
                    type="number"
                    size="is-small"
                    v-model="props.row.order_number"
                    :disabled="isDestroy(props.row)"
                  )
            b-table-column(field="remaining_number" label="残数" width="50")
              | {{ props.row.limit_order_number - props.row.order_number }}
            b-table-column(field="" label="")
              b-field
                a.delete(@click="clickDeleteButton(props.row)")
          template(v-else)
            b-table-column(field="order_number" label="配本数" width="80")
              b-field {{ props.row.order_number }}
    div(v-if="isEditable" class="columns mt-s")
      .column
        button(@click="submit" class="button is-primary")
          span.icon.icon-left
            i.fas.fa-sync-alt.fa-sm.fa-fw
          | {{ button_label }}

</template>

<script>

  // import IsbnInput from 'inputs/isbn_input'
  // import AgencyShopCodeInput from 'inputs/agency_shop_code_input'
  // import AcceptingOrderRouteIdInput from 'inputs/accepting_order_route_id_input'
  import DeliverTypeIdInput from 'inputs/deliver_type_id_input'
  // import SalesPersonIdInput from 'inputs/sales_person_id_input'
  // import ModalCsvImportForm from 'components/accepting_orders/modal_csv_import_form'
  import ManipulatedOrderItem from 'models/manipulated_order_item'
  import CacheDispatcher from 'mixins/cache_dispatcher'
  import { ValidationProvider } from 'vee-validate'

  export default {
    name: 'abstract-manipulated-order-fields',
    mixins: [CacheDispatcher],
    components: {
      DeliverTypeIdInput,
      ValidationProvider
    },
    data() {
      return {
        manipulated_order_items: [],
        loading: false,
        first_flag: true,
        is_component_modal_csv_import_active: false,
      }
    },
    props: {
      manipulated_order_id: {
        type: String,
        required: false
      },
      manipulated_order_sid: {
        type: String,
        required: false
      },
      action_name: {
        type: String,
        required: true
      },
      button_label: {
        type: String,
        required: true
      }
    },
    computed: {
      isEditable(){
        return this.action_name != 'show'
      },
      manipulated_order(){
        var a = this.$store.getters['ManipulatedOrder/record']
        if(this.first_flag && a){
          this.loading = false
          this.first_flag = false
          this.manipulated_order_items = []
          a.manipulated_order_items.forEach((item) => {
            this.manipulated_order_items.push(Object.assign({}, new ManipulatedOrderItem(item)))
          })
        }
        return a
      },
      accepting_order_routes(){ return this.$store.getters['AcceptingOrderRoutes/records'] },
      agencies(){ return this.$store.getters['Agencies/records'] },
      shop_people(){ return this.$store.getters['ShopPeople/records'] },
      deliver_types(){ return this.$store.getters['DeliverTypes/records'] },
      sales_people(){ return this.$store.getters['SalesPeople/records'] },
      final_book_shop_agencies() { return this.$store.getters['FinalBookShopAgencies/records'] },
    },
    methods:{
      bookName(isbn, name) {
        return `${name}:${isbn}`
      },
      agencyName(agency_code){
        if (!agency_code) return ''
        let tmp = this.agencies
            .filter(agency => agency.code == agency_code)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      orderRouteName(id){
        if (!id) return ''
        let tmp = this.accepting_order_routes
            .filter(route => route.id == id)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      deliverTypeName(id){
        if (!id) return ''
        let tmp = this.deliver_types
            .filter(type => type.id == id)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      salesPersonName(id){
        if (!id) return ''
        let tmp = this.sales_people
            .filter(type => type.id == id)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      addRow(event){
        this.manipulated_order_items.push(Object.assign({}, new ManipulatedOrderItem()))
      },
      has_errors() {
        return document.querySelector("input.is-danger")
      },
      submitRequest(){
        var method = this.action_name == "new" ? 'post' : 'put'
        var url = this.action_name == "new" ? `/api/v1/manipulated_orders.json` : `/api/v1/manipulated_orders/${this.manipulated_order_id}.json`
        var params = {
          manipulated_order: {
            deliver_type_id: this.manipulated_order.deliver_type_id,
            manipulated_order_items_attributes: this.manipulated_order_items
          }
        }
        return this.$http({ method: method, url: url, data: params })
      },
      submit(){
        this.loading = true
        if(this.has_errors()) {
          this.loading = false
          this.$toast.open({
            message: '登録情報エラーです。登録情報を確認してください。',
            type: 'is-danger',
            position: 'is-bottom',
            duration: 4000
          })
          return
        }
        this.submitRequest().then(({data}) => {
          this.loading = false
          window.location.href = `/users/manipulated_orders/${data.manipulated_order.id}/edit`
        })
        .catch((error) => {
          this.loading = false
          throw error
        })
      },
      fetchManipulatedOrder(){
        if(this.manipulated_order_id == null)
          return false

        this.loading = true
        this.$store.dispatch('ManipulatedOrder/fetch', [ 'manipulated_orders', this.manipulated_order_id, { record_name: 'manipulated_order' }])
        // this.$http.get(`/api/v1/accepting_orders/${this.accepting_order_id}.json`)
        //     .then(({data}) => {
        //       this.accepting_order = data.accepting_order
        //       data.accepting_order.accepting_order_items.forEach((item) => {
        //         this.accepting_order_items.push(Object.assign({}, new AcceptingOrderItem(item)))
        //       })
        //       this.loading = false
        //     })
        //     .catch((error) => {
        //       this.accepting_order = []
        //       this.accepting_order_items = []
        //       this.loading = false
        //       throw error
        //     })
      },
      clickDeleteButton(manipulated_order_item){
        if(manipulated_order_item._destroy == null){
          manipulated_order_item._destroy = "1"
        }else{
          manipulated_order_item._destroy = null
        }
      },
      isDestroy(manipulated_order_item){
        return manipulated_order_item._destroy == "1"
      },
      isShinkan() {
        return this.manipulated_order_items[0].book.is_shinkan
      }
    },
    created(){
      this.fetchManipulatedOrder()
      this.dispatch_with_cache('Agencies/fetch', 'agencies', this.agencies)
      this.dispatch_with_cache('FinalBookShopAgencies/fetch', [ 'final_book_shop_agencies', null, { query: 'mode=simple' }], this.final_book_shop_agencies)
      this.dispatch_with_cache('AcceptingOrderRoutes/fetch', 'accepting_order_routes', this.accepting_order_routes)
      this.$store.dispatch('DeliverTypes/fetch', 'deliver_types')
      this.dispatch_with_cache('SalesPeople/fetch', 'sales_people', this.sales_people)
    }
  }
</script>